/**
 * NativeWaves Identity API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class UsersApi extends runtime.BaseAPI {
    /**
     * Get user information.
     */
    async usersUserIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null ||
            requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling usersUserIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/users/{userId}`.replace(`{${'userId'}}`, String(requestParameters.userId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get user information.
     */
    async usersUserIdGet(requestParameters, initOverrides) {
        const response = await this.usersUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List personal access tokens
     */
    async usersUserIdPersonalAccessTokensGetRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null ||
            requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling usersUserIdPersonalAccessTokensGet.');
        }
        const queryParameters = {};
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/users/{userId}/personalAccessTokens`.replace(`{${'userId'}}`, String(requestParameters.userId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List personal access tokens
     */
    async usersUserIdPersonalAccessTokensGet(requestParameters, initOverrides) {
        const response = await this.usersUserIdPersonalAccessTokensGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new personal access token
     */
    async usersUserIdPersonalAccessTokensPostRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null ||
            requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling usersUserIdPersonalAccessTokensPost.');
        }
        if (requestParameters.personalAccessTokenInsert === null ||
            requestParameters.personalAccessTokenInsert === undefined) {
            throw new runtime.RequiredError('personalAccessTokenInsert', 'Required parameter requestParameters.personalAccessTokenInsert was null or undefined when calling usersUserIdPersonalAccessTokensPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/users/{userId}/personalAccessTokens`.replace(`{${'userId'}}`, String(requestParameters.userId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.personalAccessTokenInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new personal access token
     */
    async usersUserIdPersonalAccessTokensPost(requestParameters, initOverrides) {
        const response = await this.usersUserIdPersonalAccessTokensPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a personal access token
     */
    async usersUserIdPersonalAccessTokensTokenIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null ||
            requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling usersUserIdPersonalAccessTokensTokenIdDelete.');
        }
        if (requestParameters.tokenId === null ||
            requestParameters.tokenId === undefined) {
            throw new runtime.RequiredError('tokenId', 'Required parameter requestParameters.tokenId was null or undefined when calling usersUserIdPersonalAccessTokensTokenIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/users/{userId}/personalAccessTokens/{tokenId}`
                .replace(`{${'userId'}}`, String(requestParameters.userId))
                .replace(`{${'tokenId'}}`, String(requestParameters.tokenId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a personal access token
     */
    async usersUserIdPersonalAccessTokensTokenIdDelete(requestParameters, initOverrides) {
        await this.usersUserIdPersonalAccessTokensTokenIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a personal access token
     */
    async usersUserIdPersonalAccessTokensTokenIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null ||
            requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling usersUserIdPersonalAccessTokensTokenIdGet.');
        }
        if (requestParameters.tokenId === null ||
            requestParameters.tokenId === undefined) {
            throw new runtime.RequiredError('tokenId', 'Required parameter requestParameters.tokenId was null or undefined when calling usersUserIdPersonalAccessTokensTokenIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/users/{userId}/personalAccessTokens/{tokenId}`
                .replace(`{${'userId'}}`, String(requestParameters.userId))
                .replace(`{${'tokenId'}}`, String(requestParameters.tokenId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a personal access token
     */
    async usersUserIdPersonalAccessTokensTokenIdGet(requestParameters, initOverrides) {
        const response = await this.usersUserIdPersonalAccessTokensTokenIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a personal access token if the provided hash validation is successful.
     */
    async usersUserIdPersonalAccessTokensTokenIdHashValidationHashValidationGetRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null ||
            requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling usersUserIdPersonalAccessTokensTokenIdHashValidationHashValidationGet.');
        }
        if (requestParameters.tokenId === null ||
            requestParameters.tokenId === undefined) {
            throw new runtime.RequiredError('tokenId', 'Required parameter requestParameters.tokenId was null or undefined when calling usersUserIdPersonalAccessTokensTokenIdHashValidationHashValidationGet.');
        }
        if (requestParameters.hashValidation === null ||
            requestParameters.hashValidation === undefined) {
            throw new runtime.RequiredError('hashValidation', 'Required parameter requestParameters.hashValidation was null or undefined when calling usersUserIdPersonalAccessTokensTokenIdHashValidationHashValidationGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/users/{userId}/personalAccessTokens/{tokenId}/hashValidation/{hashValidation}`
                .replace(`{${'userId'}}`, String(requestParameters.userId))
                .replace(`{${'tokenId'}}`, String(requestParameters.tokenId))
                .replace(`{${'hashValidation'}}`, String(requestParameters.hashValidation)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a personal access token if the provided hash validation is successful.
     */
    async usersUserIdPersonalAccessTokensTokenIdHashValidationHashValidationGet(requestParameters, initOverrides) {
        const response = await this.usersUserIdPersonalAccessTokensTokenIdHashValidationHashValidationGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a personal access token
     */
    async usersUserIdPersonalAccessTokensTokenIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null ||
            requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling usersUserIdPersonalAccessTokensTokenIdPatch.');
        }
        if (requestParameters.tokenId === null ||
            requestParameters.tokenId === undefined) {
            throw new runtime.RequiredError('tokenId', 'Required parameter requestParameters.tokenId was null or undefined when calling usersUserIdPersonalAccessTokensTokenIdPatch.');
        }
        if (requestParameters.personalAccessTokenEdit === null ||
            requestParameters.personalAccessTokenEdit === undefined) {
            throw new runtime.RequiredError('personalAccessTokenEdit', 'Required parameter requestParameters.personalAccessTokenEdit was null or undefined when calling usersUserIdPersonalAccessTokensTokenIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/users/{userId}/personalAccessTokens/{tokenId}`
                .replace(`{${'userId'}}`, String(requestParameters.userId))
                .replace(`{${'tokenId'}}`, String(requestParameters.tokenId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.personalAccessTokenEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a personal access token
     */
    async usersUserIdPersonalAccessTokensTokenIdPatch(requestParameters, initOverrides) {
        const response = await this.usersUserIdPersonalAccessTokensTokenIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
//# sourceMappingURL=UsersApi.js.map